import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { relayStylePagination } from "@apollo/client/utilities";
import { createApolloProvider } from "@vue/apollo-option";
import { SentryLink } from "apollo-link-sentry";
import { onError } from "@apollo/client/link/error";
import { ApolloLink } from "@apollo/client";

const isDevelopment = process.env.NODE_ENV === "development";

const httpLink = createHttpLink({
  uri: ({ operationName }) =>
    `${process.env.SHOPIFY_STOREFRONT_API_URL}?op=${operationName}`,
});

const cache = new InMemoryCache({
  typePolicies: {
    Collection: {
      fields: {
        products: relayStylePagination(),
      },
    },
  },
});

const sentryLink = new SentryLink();
const errorLink = onError((error) => {
  console.log("APOLLO", error);
});

const links = [sentryLink, errorLink, httpLink];

if (isDevelopment) {
  const responseModificationLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      const traverseAndModify = (obj) => {
        if (obj === null || typeof obj !== "object") {
          return obj;
        }

        if (Array.isArray(obj)) {
          return obj.map(traverseAndModify);
        }

        if (Object.prototype.hasOwnProperty.call(obj, "onlineStoreUrl")) {
          obj.onlineStoreUrl = modifyUrl(obj.onlineStoreUrl);
        }

        if (
          operation.operationName === "menu" &&
          Object.prototype.hasOwnProperty.call(obj, "url")
        ) {
          obj.url = modifyUrl(obj.url);
        }

        Object.keys(obj).forEach((key) => {
          obj[key] = traverseAndModify(obj[key]);
        });

        return obj;
      };

      return traverseAndModify(response);
    });
  });

  links.unshift(responseModificationLink);
}

function modifyUrl(url) {
  return url.replace(
    /https:\/\/redev.ratandboa\.com/g,
    "http://127.0.0.1:9292"
  );
}

let link = ApolloLink.from(links);

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    "X-Shopify-Storefront-Access-Token":
      process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  },
}));

link = authLink.concat(link);

export const client = new ApolloClient({
  link,
  cache,
});

export const apolloProvider = createApolloProvider({
  defaultClient: client,
});
